import { hideLoading, showLoading } from './reducer';

export const appAction = {
  showLoading,
  hideLoading,
};
